import React from 'react';
import Layout from './components/Layout';
import BridgeProvider from './BridgeContext';

const PageWrapper = ({ props, element }: any) => <BridgeProvider><Layout {...props}>{element}</Layout></BridgeProvider>;

export default PageWrapper;